import { motion, useReducedMotion } from "framer-motion";
import DashboardMockup from "@/components/home/DashboardMockup";
import { EASE } from "@/components/motion/Reveal";

/**
 * El panel sube por encima de la fotografía del hero. El traslape es lo que
 * conecta la promesa (la foto) con el producto (el panel).
 */
export default function PanelShowcase() {
    const reduce = useReducedMotion();
    return (
        <section data-testid="home-panel" className="relative z-10 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={reduce ? false : { opacity: 0, y: 48 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: reduce ? 0 : 0.8, ease: EASE }}
                    className="-mt-28 sm:-mt-36 lg:-mt-48"
                >
                    <DashboardMockup />
                </motion.div>

                <p className="mt-10 text-center text-[15px] text-[#4A4A4A] max-w-xl mx-auto">
                    Este es tu panel: ventas, pedidos y guías de envío en la
                    misma pantalla, desde el primer día.
                </p>
            </div>
        </section>
    );
}
